import { Typography } from '../../../typography/typography.component';
import {
  CALENDAR_GRID_DEFAULTS,
  CALENDAR_GRID_HOURS_12,
  CALENDAR_GRID_HOURS_24,
} from '../../constants';
import {
  CalendarGridColumn,
  CalendarGridColumnProps,
} from '../calendar-grid-column/calendar-grid-column.component';
import { CalendarGridTimeMode } from '../../types';

export type CalendarGridTimeColumnProps = Omit<
  CalendarGridColumnProps,
  'cellCount' | 'renderCellContent'
> & {
  mode?: CalendarGridTimeMode;
};

export const CalendarGridTimeColumn = ({
  mode = '12H',
  minWidth,
  ...rest
}: CalendarGridTimeColumnProps) => {
  const source = mode === '24H' ? CALENDAR_GRID_HOURS_24 : CALENDAR_GRID_HOURS_12;
  const width = minWidth || CALENDAR_GRID_DEFAULTS.timeColumnMinWidth * (mode === '24H' ? 1 : 1.5);

  return (
    <CalendarGridColumn
      cellCount={source.length}
      minWidth={width}
      sx={{ width }}
      renderCellContent={(index, _id, textColor) => (
        <Typography
          variant='body2'
          sx={{ whiteSpace: 'nowrap' }}
          color={textColor}
          textTransform='uppercase'
        >
          {source[index]}
        </Typography>
      )}
      {...rest}
    />
  );
};
